import { render, staticRenderFns } from "./ConsultaPlantaoUnidades.vue?vue&type=template&id=0fe0a505"
import script from "./ConsultaPlantaoUnidades.vue?vue&type=script&lang=js"
export * from "./ConsultaPlantaoUnidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports